import { IconProps } from "../../types/utils";

const Account = ({ color, dimension, ...props }: IconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M25.3333 25.5554C25.3333 26.0874 24.9021 26.5183 24.3705 26.5183C23.8385 26.5183 23.4072 26.0874 23.4072 25.5554C23.4072 21.8325 20.3896 18.8149 16.6667 18.8149C12.9438 18.8149 9.9261 21.8326 9.9261 25.5554C9.9261 26.0874 9.49486 26.5183 8.96288 26.5183C8.43122 26.5183 8 26.0874 8 25.5554C8 20.7688 11.8801 16.8888 16.6667 16.8888C21.4532 16.8888 25.3333 20.7689 25.3333 25.5554ZM16.6667 15.9258C13.7417 15.9258 11.3702 13.5547 11.3702 10.6294C11.3702 7.70437 13.7417 5.33325 16.6667 5.33325C19.5917 5.33325 21.9631 7.70437 21.9631 10.6294C21.9631 13.5546 19.5917 15.9258 16.6667 15.9258ZM16.6667 14.0001C18.5279 14.0001 20.037 12.4911 20.037 10.6295C20.037 8.76819 18.5279 7.25917 16.6667 7.25917C14.8054 7.25917 13.2964 8.76819 13.2964 10.6295C13.2964 12.4911 14.8054 14.0001 16.6667 14.0001Z"
      fill={color || "#242424"}
    />
  </svg>
);

export default Account;
